import { createFileRoute } from "@tanstack/react-router";
import { DomainBadgeExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute(
  "/demo/design-system/specialty/domain-badge",
)({
  component: DomainBadgeExamples,
});
